/*
 * @Author: Latte
 * @Date: 2021-08-20 11:47:38
 * @LAstEditors: Latte
 * @LastEditTime: 2021-09-02 11:05:34
 * @FilePath: \Siui.Cloud.Medical.Web\src\config\tableConfig\liveManagement.js
 */

/**
 * 首页表格配置项
 * 
 * 完整配置
 *  prop  单元格数据（非特殊类型必填）
    label  单元格标题（非特殊类型必填）
    type  类型
    width  宽度
    header-align 表头位置
    align  内容位置
    hasFilter  判断过滤器
    filter 过滤器
 */
export const liveMgtConf = Object.freeze({
	tableColumnOpt: [
		{
			label: "地址",
			prop: "address",
		},
		{
			label: "ID",
			prop: "liveID",
		},
		{
			label: "业务",
			prop: "userDataType",
		},
		{
			label: "状态",
			prop: "liveState",
		},
		{
			label: "标题",
			prop: "liveTitle",
		},
		{
			label: "主播ID",
			prop: "hostUserID",
		},
		{
			label: "开播时间",
			prop: "LiveBeginDatetime",
		},
		{
			label: "结束时间",
			prop: "deleteTime",
		},
		{
			label: "观看总人数",
			prop: "totalMemberCount",
		},
		{
			label: "真实人数",
			prop: "watchCount",
		},
		{
			label: "虚拟人数",
			prop: "totalVirtualUsers",
		},
		{
			label: "邀请码",
			prop: "invitationCode",
		},
	],
	hasStatus: false,
  operationWidth: "700",
});
